import FormElement from './form-element.js';
import '../../jquery.nouislider.js';
import shortNumber from '../short-number.js';
import moment from 'moment';

class Sliders extends FormElement {
	#container;
	#elements = {};

	constructor(container) {
		super();

		if (container instanceof jQuery) {
			container = container[0];
		}

		this.#container = container;

		this.#init();
	}

	#init() {
		const sliders = this.#container.querySelectorAll(".slider:not(.noUi-target)");
		const handleHtml = $(".handle-html").html();

		if (this.#container) {
			$(this.#container).on('shown.bs.collapse hidden.bs.collapse', '#filters-advanced-filters', () => {
				const advanced = $(this.#container).find('.filters-advanced');
				const input = advanced.find("[name='use_advanced']");
				const toggled = advanced.data('toggled') === 1 ? 0 : 1;

				// set data, and input value
				advanced.data('toggled', toggled);

				if (input.length) {
					input.val(toggled ? 1 : 0).trigger('change');
				}

				$(this.#container).trigger('toggleAdvanced');
			});
		}

		for (const el of sliders) {
			const slider = $(el);
			const name = slider.data('name');
			const isRange = +slider.data('range') === 1;

			slider.noUiSlider({
				start: slider.data('start'),
				step: slider.data('step'),
				behaviour: 'snap',
				range: {
					min: slider.data('min'),
					max: slider.data('max')
				}
			});

			slider.find('.noUi-handle-lower').html(handleHtml).find('.slider-handle-label-text').text(slider.data('start')[0]);

			if (isRange) {
				slider.find('.noUi-handle-upper').html(handleHtml).find('.slider-handle-label-text').text(slider.data('start')[1]);
			}

			this.#elements[ name ] = slider;

			slider.on('slide set', e => {
				this.#handleUpdate(name, slider.val(), e.type === 'set');
			});

			this.#handleUpdate(name, slider.val(), false);
		}
	}

	set(name, value, ... args) {
		if (this.#elements.hasOwnProperty(name)) {
			const result = this.#handleUpdate(name, value, true, ... args);

			this.#elements[ name ].val(this.get(name));

			return result;
		} else {
			console.warn(`attempting to set value of slider ${name} which doesn't exist`);
		}
	}

	update(name, value) {
		if (this.#elements.hasOwnProperty(name)) {
			const result = this.#handleUpdate(name, value, false);

			this.#elements[ name ].val(this.get(name));

			return result;
		} else {
			console.warn(`attempting to update value of slider ${name} which doesn't exist`);
		}
	}

	reset(name = null) {
		if (!name) {
			for (const key of Object.keys(this.#elements)) {
				this.reset(key);
			}
			return;
		}

		const slider = this.#elements[ name ];

		return this.update(name, slider.data('start'));
	}

	#handleUpdate(name, value, callback = true, ... args) {
		const slider = this.#elements[ name ];
		const input = slider[0].querySelector('input');

		const isRange = +slider.data('range') === 1;
		const step = slider.data('step') || 1;
		const multiplier = slider.data('multiplier') || 1;

		const parseVal = step === Math.round(step) ? parseInt : parseFloat;

		const min = parseVal(slider.data('min'));
		const max = parseVal(slider.data('max'));

		if (isRange && !_.isArray(value)) {
			value = value.split(',');
		}

		let lower = isRange ? parseVal(value[0]) : parseVal(value);

		if (lower > max) {
			lower = max;
		} else if (lower < min) {
			lower = min;
		}

		let upper = isRange ? parseVal(value[1]) : null;

		if (isRange) {
			if (upper > max) {
				upper = max;
			} else if (upper < min) {
				upper = min;
			}
		}

		const newValue = isRange ? [ lower, upper ] : lower;
		const changed = !_.isEqual(this.get(name), newValue);

		super.store(name, newValue);

		const format = slider.data('format');
		const dateFormat = slider.data('dateFormat');
		const predefinedValues = slider.data('predefinedValues');
		const useShortNumber = slider.data('shortNumber') === 1;

		const minExtend = slider.data('minExtend') === 1;
		const maxExtend = slider.data('maxExtend') === 1;
		const decimals = slider.data('decimals') || 0;

		let lowerLabel = lower * multiplier;
		let upperLabel = upper * multiplier;

		if (predefinedValues?.[ lower ]) {
			lowerLabel = predefinedValues[ lower ];
		}

		if (predefinedValues?.[ upper ]) {
			upperLabel = predefinedValues[ upper ];
		}

		if (useShortNumber) {
			lowerLabel = shortNumber(lowerLabel);
			upperLabel = shortNumber(upperLabel);
		} else if (decimals > 0) {
			lowerLabel = lowerLabel.toFixed(decimals);
			upperLabel = upperLabel.toFixed(decimals);
		} else if (dateFormat) {
			lowerLabel = moment(lowerLabel).format(dateFormat);
			upperLabel = moment(upperLabel).format(dateFormat);
		}

		lowerLabel = format.replace('[value]', lowerLabel);

		if (isRange) {
			upperLabel = format.replace('[value]', upperLabel);
		}

		if (lower === slider.data('min') && minExtend) {
			lowerLabel += '-';
		}

		if (upper === slider.data('max') && maxExtend) {
			upperLabel += '+';
		}

		slider.find('.noUi-handle-lower .slider-handle-label-text').html(lowerLabel);
		$(`[data-slider-name="${name}"][data-slider-value="lower"]`).text(lowerLabel);

		if (isRange) {
			slider.find('.noUi-handle-upper .slider-handle-label-text').html(upperLabel);
			$(`[data-slider-name="${name}"][data-slider-value="upper"]`).text(upperLabel);
		}

		input.value = lower + (isRange ? ',' + upper : '');

		super.runCallback(name, 'update', ... args);

		if (callback) {
			super.runCallback(name, 'set', ... args);
		}

		return changed;
	}
}

function init(container) {
	return new Sliders(container);
};

export default { init };
